<template>
  <div v-if="isAuthenticated" class="max-w-6xl p-4 mx-auto">
    <div class="grid grid-cols-3 mt-5">
      <div>
        <h1 class="mb-5 font-medium">My Account</h1>
        <div class="flex flex-col items-start border-t bg-stone-100 w-60">
          <button
            class="p-2 text-sm font-light text-start"
            :class="{
              'border-secondary border-l-2': selectedSection === 'personalInfo',
            }"
            @click="selectSection('personalInfo')"
          >
            Personal Information
          </button>
          <hr class="w-full border-gray-300" />
          <button
            class="w-full p-2 text-sm font-light text-start"
            :class="{
              'border-secondary border-l-2':
                selectedSection === 'savedProperties',
            }"
            @click="selectSection('savedProperties')"
          >
            Saved Properties
          </button>
        </div>
      </div>
      <div class="col-span-2">
        <UserDetails v-if="selectedSection === 'personalInfo'" />
        <Properties
          v-if="selectedSection === 'savedProperties'"
          :properties="properties"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import UserDetails from "@/features/profile/UserDetails.vue";
import Properties from "@/features/properties/PropertyCard.vue";
import { getWishlistProperties } from "@/composables/useWishlist";
import useAuth from "@/composables/useAuth";

export default {
  components: {
    UserDetails,
    Properties,
  },
  data() {
    return {
      selectedSection: "personalInfo", // Default section
      properties: [], // Will hold the wishlist properties
      isAuthenticated: false, // Initialize authentication state
    };
  },
  created() {
    const router = useRouter();
    const { state } = useAuth();

    this.isAuthenticated = state.isAuthenticated;

    if (!this.isAuthenticated) {
      router.push("/");
    } else {
      this.loadWishlistProperties();
    }
  },
  methods: {
    selectSection(section) {
      this.selectedSection = section;
    },
    loadWishlistProperties() {
      this.properties = getWishlistProperties();
    },
  },
};
</script>
